import { Theme, css } from '@emotion/react';

export const root = ({ spacing, breakpoints }: Theme) => css`
  align-items: flex-start;
  background-color: transparent;
  display: flex;
  padding: ${spacing(3)}px;
  gap: ${spacing(2)}px;
  width: 100%;
  ${breakpoints.up('md')} {
    align-items: center;
  }
`;

export const content = ({ breakpoints }: Theme) => css`
  text-align: left;
  flex: 1;
  min-width: 0;
`;

export const thumbContainer = ({ spacing, breakpoints }: Theme) => css`
  flex: 0 0 5.6rem;
  ${breakpoints.up('md')} {
    flex: 0 0 21.7rem;
  }
`;

export const link = ({ interactiveStates, colors }: Theme) => css`
  text-decoration: none;
  &:focus {
    outline: none;
  }
  &:focus-visible {
    box-shadow: none;
  }
  ${interactiveStates.focus(css`
    & .BusinessHeader {
      box-shadow: inset 0 0 0 2px ${colors.borderPrimaryBase};
    }
  `)}
`;
